/* eslint-disable no-prototype-builtins */
export class LeadTrackerCoockie {
    /* Lead Tracker Cookie */
    static storeLeadTrackerCookie(leadWindow) {
        var _a;
        const leadData = leadWindow.dataList;
        if (typeof leadWindow.DealeronCookie == "object") {
            let dataString = "";
            if (leadData.hasOwnProperty("LeadId")) {
                dataString += "LeadId=" + leadData["LeadId"] + "|";
            }
            if (leadData.hasOwnProperty("Vin") && leadData["Vin"].length > 0) {
                dataString += "Vin=" + leadData["Vin"] + "|";
            }
            else {
                if (leadData.hasOwnProperty("VehicleType")) {
                    dataString += "VehicleType=" + leadData["VehicleType"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleYear")) {
                    dataString += "VehicleYear=" + leadData["VehicleYear"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleMake")) {
                    dataString += "VehicleMake=" + leadData["VehicleMake"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleModel")) {
                    dataString += "VehicleModel=" + leadData["VehicleModel"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleTrim")) {
                    dataString += "VehicleTrim=" + leadData["VehicleTrim"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleExteriorColor")) {
                    dataString +=
                        "VehicleExtColor=" + leadData["VehicleExteriorColor"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleInteriorColor")) {
                    dataString +=
                        "VehicleIntColor=" + leadData["VehicleInteriorColor"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleTransmission")) {
                    dataString +=
                        "VehicleTransmission=" + leadData["VehicleTransmission"] + "|";
                }
                if (leadData.hasOwnProperty("VehicleMileage")) {
                    dataString += "VehicleMileage=" + leadData["VehicleMileage"] + "|";
                }
            }
            if (leadData.hasOwnProperty("VehicleModelCode")) {
                if (leadData["VehicleModelCode"]) {
                    dataString +=
                        "VehicleModelCode=" + leadData["VehicleModelCode"] + "|";
                }
            }
            if (leadData.hasOwnProperty("VehiclePrice")) {
                dataString += "VehiclePrice=" + leadData["VehiclePrice"] + "|";
            }
            if (leadData.hasOwnProperty("LeadType")) {
                dataString += "LeadType=" + leadData["LeadType"] + "|";
            }
            if (leadData.hasOwnProperty("Type")) {
                dataString += "Type=" + leadData["Type"] + "|";
            }
            if (leadData.hasOwnProperty("LeadSource")) {
                dataString += "LeadSourceId=" + leadData["LeadSource"] + "|";
            }
            if (leadData.hasOwnProperty("DealerId")) {
                dataString += "DealerId=" + leadData["DealerId"] + "|";
            }
            if (leadData.hasOwnProperty("PreferredContact")) {
                dataString += "PreferredContact=" + leadData["PreferredContact"] + "|";
            }
            if (leadData.hasOwnProperty("DisplayType")) {
                dataString += "DisplayType=" + leadData["DisplayType"] + "|";
            }
            if (leadData.hasOwnProperty("ApptDateTime")) {
                dataString += "AppDateTime=" + leadData["ApptDateTime"] + "|";
            }
            if (leadData.hasOwnProperty("TradeYear")) {
                dataString += "TradeYear=" + leadData["TradeYear"] + "|";
            }
            if (leadData.hasOwnProperty("TradeMake")) {
                dataString += "TradeMake=" + leadData["TradeMake"] + "|";
            }
            if (leadData.hasOwnProperty("TradeModel")) {
                dataString += "TradeModel=" + leadData["TradeModel"] + "|";
            }
            if (leadData.hasOwnProperty("Zip")) {
                dataString += "Zip=" + leadData["Zip"] + "|";
            }
            if (leadData.hasOwnProperty("OptIntoText")) {
                dataString += "OptIntoText=" + leadData["OptIntoText"] + "|";
            }
            const hasPhone = leadData.hasOwnProperty("Phone") && leadData["Phone"];
            const hasEmail = leadData.hasOwnProperty("Email") && leadData["Email"];
            if (hasPhone && hasEmail) {
                dataString += "CustomerLeadLevel=" + "PhoneAndEmail" + "|";
            }
            else if (hasEmail && !hasPhone) {
                dataString += "CustomerLeadLevel=" + "Email" + "|";
            }
            else if (hasPhone && !hasEmail) {
                dataString += "CustomerLeadLevel=" + "Phone" + "|";
            }
            if (((_a = leadWindow.location) === null || _a === void 0 ? void 0 : _a.pathname) &&
                leadWindow.location.pathname.length > 1) {
                dataString +=
                    "FormUrlPath=" + leadWindow.location.pathname.slice(1) + "|";
            }
            if (leadWindow.pageTypeKey) {
                dataString += "PageTypeKey=" + leadWindow.pageTypeKey + "|";
            }
            const daysToKeep = 30 * 60; // 30 minutes converted to seconds
            leadWindow.DealeronCookie.setItem(leadWindow.DlronGlobal_DealeronLeadTrackerCookieName, dataString, daysToKeep);
        }
    }
}
